export interface PrefixUrlHostedModel {
  key: PrefixUrlHostedEnum | string, value: string
};

enum PrefixUrlHostedEnum {
  australia = 'australia',
  europe = 'europe',
  usa = 'usa',
  stage01 = 'stage01',
  'acs-frontend-flexicapture-host' = 'acs-frontend-flexicapture-host'
};

export const PrefixUrlHostedArray: PrefixUrlHostedModel[] = [
  { key: PrefixUrlHostedEnum.australia, value: 'Australia' },
  { key: PrefixUrlHostedEnum.europe, value: 'Europe' },
  { key: PrefixUrlHostedEnum.usa, value: 'United States' },
  { key: PrefixUrlHostedEnum.stage01, value: 'Stage01' },
  { key: PrefixUrlHostedEnum['acs-frontend-flexicapture-host'], value: 'localhost' }
];

